import * as React from "react";
import PropTypes from "prop-types";
import { Route, Switch } from "react-router-dom";
import NotFoundPage from "nexia_mobile/components/Pages/NotFoundPage";

export default class SwitchWith404 extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  render() {
    const { children } = this.props;

    return (
      <Switch>
        {children}
        <Route
          // fallback
          component={NotFoundPage}
        />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Routing/SwitchWith404.jsx